import React, { useState, useEffect } from "react";
import { cls } from "cls";
import camelcase from "camelcase";
import "../../Styles/RequiredMark.less";
import "../../Styles/FormCheckbox.less";

interface FormCheckboxGroupProps {
  label: string;
  options: string[];
  formTextColor: string;
  isRequired: boolean;
  errorMessage?: string;
  inputName: string;
  setFormValue: (key: string, value: string | number | boolean) => void;
}

const FormCheckboxGroup = ({
  label,
  options,
  formTextColor,
  isRequired,
  errorMessage,
  inputName,
  setFormValue,
}: FormCheckboxGroupProps): JSX.Element => {
  const [checkedValues, setCheckedValues] = useState<number[]>([]);

  const handleCheckboxes = (index: number) => {
    if (checkedValues.includes(index)) {
      setCheckedValues(checkedValues.filter((x) => x !== index));
    } else {
      setCheckedValues([...checkedValues, index]);
    }
  };

  useEffect(() => {
    const selectedOptions = options
      .filter((x, index) => checkedValues.includes(index))
      .join(", ");
    setFormValue(inputName, selectedOptions);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [checkedValues]);

  return (
    <div id="checkbox-group" className="flex flex-col items-start pb-1">
      <p
        className={cls("font-normal", "mb-3", "text-base", "leading-[18px]", {
          required: isRequired,
        })}
        style={{
          color: formTextColor,
          textShadow: "none",
        }}
      >
        {label}
      </p>
      <div className="grid grid-cols-1 gap-x-8 sm:grid-cols-2">
        {options?.map((option, index) => (
          <div key={option} className="flex items-start space-x-2 mb-6">
            <input
              className={cls("!mt-0", {
                error: errorMessage,
                checkbox: !errorMessage,
              })}
              type="checkbox"
              name={camelcase(option)}
              id={`${option}-checkbox`}
              checked={checkedValues.includes(index)}
              onChange={() => handleCheckboxes(index)}
            />
            <label
              htmlFor={`${option}-checkbox`}
              className="font-normal m-0"
              style={{
                color: formTextColor,
                textShadow: "none",
              }}
            >
              {option}
            </label>
          </div>
        ))}
      </div>
      <span
        className="-mt-1 h-4 mb-0 text-xs text-red-600"
        style={{ visibility: errorMessage ? "visible" : "hidden" }}
      >
        At least one selection from {label} is required
      </span>
    </div>
  );
};

export default FormCheckboxGroup;
